import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import HeroImage from '../images/hero-digital-connection.png';
import './style.css';

function HeroSection() {
  return (
    <section id="hero" className="hero-section">
      <Container>
        <Row className="align-items-center">
          <Col md="6" className="text-center text-md-start mb-4 mb-md-0">
            <h1 className="hero-title">
              We connect{' '}
              <span className="hero-highlight">
                strategy, design, and technology
              </span>{' '}
              to grow your brand
            </h1>
            <p className="hero-subtitle">
              At SJ Social Media, we believe every business deserves a powerful, personalized digital presence.
            </p>
          </Col>
          <Col md="6" className="text-center">
            <img
              src={HeroImage}
              alt="Digital Connection Illustration"
              className="img-fluid hero-image"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default HeroSection;
